import * as React from 'react';
import useEffect from '../utils/use_effect';
var pxToNumber = pxValue => {
  return Number(pxValue.slice(0, -2));
};
var useBreadcrumbsOverflow = function useBreadcrumbsOverflow(navRef, listRef) {
  var responsiveBreakpoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var breakpointValue = pxToNumber(responsiveBreakpoint);
  var [isOverflow, setIsOverflow] = React.useState(false);
  var [clientWidth, setClientWidth] = React.useState(0);
  var [isGreaterThanBreakpoint, setIsGreaterThanBreakpoint] = React.useState(false);
  useEffect(() => {
    var {
      current: listNode
    } = listRef;
    var {
      current: navNode
    } = navRef;
    (navNode === null || navNode === void 0 ? void 0 : navNode.clientWidth) && setIsGreaterThanBreakpoint((navNode === null || navNode === void 0 ? void 0 : navNode.clientWidth) > breakpointValue);
    setClientWidth((listNode === null || listNode === void 0 ? void 0 : listNode.clientWidth) || 0);
  }, [breakpointValue, isGreaterThanBreakpoint, listRef, navRef, responsiveBreakpoint]);
  useEffect(() => {
    function trigger() {
      var {
        current: navNode
      } = navRef;
      if (navNode !== null && navNode !== void 0 && navNode.clientWidth && (navNode === null || navNode === void 0 ? void 0 : navNode.clientWidth) > breakpointValue !== isGreaterThanBreakpoint) {
        setIsOverflow(false);
        setIsGreaterThanBreakpoint((navNode === null || navNode === void 0 ? void 0 : navNode.clientWidth) > breakpointValue);
      } else if (navNode !== null && navNode !== void 0 && navNode.clientWidth) {
        var hasOverflow = (navNode === null || navNode === void 0 ? void 0 : navNode.scrollWidth) <= clientWidth;
        setIsOverflow(hasOverflow);
      }
    }
    window.addEventListener('resize', trigger);
    trigger();
    return () => window.removeEventListener('resize', trigger);
  }, [breakpointValue, clientWidth, isGreaterThanBreakpoint, listRef, navRef]);
  return isOverflow;
};
export default useBreadcrumbsOverflow;